import React from 'react';
export function FiberAdvantagesSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-6" data-id="element-1511">
      <h2 className="text-2xl md:text-3xl font-bold text-navy border-b border-gray-200 pb-4" data-id="element-1512">
        Advantages of Fiber Lasers
      </h2>
      <p className="text-gray-700 text-lg" data-id="element-1513">
        Fiber laser cutting offers several advantages over CO2 laser cutting in
        various applications. Here are some benefits of fiber laser cutting:
      </p>

      <ul className="space-y-6 text-gray-700 text-lg" data-id="element-1514">
        <li className="flex items-start" data-id="element-1515">
          <span className="text-orange mr-2 mt-1" data-id="element-1516">•</span>
          <div data-id="element-1517">
            <strong data-id="element-1518">Higher Efficiency:</strong> Fiber lasers are more efficient
            than CO2 lasers, converting a higher percentage of input energy into
            laser light. This increased efficiency leads to lower power
            consumption and operating costs.
          </div>
        </li>
        <li className="flex items-start" data-id="element-1519">
          <span className="text-orange mr-2 mt-1" data-id="element-1520">•</span>
          <div data-id="element-1521">
            <strong data-id="element-1522">Faster Cutting Speeds:</strong> Fiber lasers are capable of
            achieving higher cutting speeds compared to CO2 lasers. The
            concentrated and intense laser beam produced by fiber lasers allows
            for faster material processing, resulting in increased productivity.
          </div>
        </li>
        <li className="flex items-start" data-id="element-1523">
          <span className="text-orange mr-2 mt-1" data-id="element-1524">•</span>
          <div data-id="element-1525">
            <strong data-id="element-1526">Greater Precision:</strong> Fiber lasers provide superior
            beam quality, which enables precise and accurate cutting. The
            focused laser beam allows for narrow kerf widths and smaller
            heat-affected zones, resulting in cleaner and more precise cuts.
          </div>
        </li>
        <li className="flex items-start" data-id="element-1527">
          <span className="text-orange mr-2 mt-1" data-id="element-1528">•</span>
          <div className="space-y-4" data-id="element-1529">
            <strong data-id="element-1530">Versatility with Materials:</strong> Fiber lasers are
            well-suited for cutting a wide range of materials, including metals
            (such as steel, aluminum, and copper) as well as non-metallic
            materials like plastics and composites. CO2 lasers, on the other
            hand, are primarily used for non-metal materials.
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 space-y-4 mt-4" data-id="element-1531">
              <div data-id="element-1532">
                <h3 className="font-bold text-navy mb-2" data-id="element-1533">
                  Good with thin materials
                </h3>
                <p data-id="element-1534">
                  Although fiber lasers are good at working with materials of
                  all thicknesses, they are particularly great at working with
                  thin materials, including metals. Using the same comparison of
                  lasers as above, the fiber laser is three times faster at
                  cutting in a straight line on something like stainless steel
                  with a 1mm thickness, and two times faster if the same
                  material is 2mm in thickness.
                </p>
              </div>
              <div data-id="element-1535">
                <h3 className="font-bold text-navy mb-2" data-id="element-1536">Reflective metals</h3>
                <p data-id="element-1537">
                  Fiber lasers can cut reflective materials without having to
                  worry about back reflections that could damage the machine.
                </p>
              </div>
            </div>
          </div>
        </li>
        <li className="flex items-start" data-id="element-1538">
          <span className="text-orange mr-2 mt-1" data-id="element-1539">•</span>
          <div data-id="element-1540">
            <strong data-id="element-1541">Lower Maintenance and Operating Costs:</strong> Fiber lasers
            have a simpler design with fewer moving parts compared to CO2
            lasers. This leads to reduced maintenance requirements and costs.
            Additionally, fiber lasers typically have a longer lifespan,
            providing more reliable and cost-effective operation over time.
          </div>
        </li>
        <li className="flex items-start" data-id="element-1542">
          <span className="text-orange mr-2 mt-1" data-id="element-1543">•</span>
          <div data-id="element-1544">
            <strong data-id="element-1545">Compact Size:</strong> Fiber laser systems are generally
            more compact and take up less floor space than CO2 lasers. This
            makes them suitable for installations in smaller work environments.
          </div>
        </li>
      </ul>

      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mt-8 text-gray-700 text-lg italic" data-id="element-1546">
        <p data-id="element-1547">
          It's worth noting that while fiber lasers excel in many areas, CO2
          lasers still have their own advantages in certain applications, such
          as thicker materials and engraving. The choice between fiber and CO2
          lasers depends on the specific requirements of the cutting
          application, material type, thickness, and desired outcome.
        </p>
      </div>
    </div>;
}